import { es, en, ptBr } from './locale';
import routes from './routes';

const AnaliseDesmatamentoModule = {
    init: ({ i18n, router }) => {
        i18n.mergeLocaleMessage('pt-BR', {
            'analyze-deforestation': {
                ...ptBr
            }
        });
        i18n.mergeLocaleMessage('en', {
            'analyze-deforestation': {
                ...en
            }
        });
        i18n.mergeLocaleMessage('es', {
            'analyze-deforestation': {
                ...es
            }
        });

        router.addRoutes(routes);
    }
};

export default AnaliseDesmatamentoModule;
